module.exports = __webpack_public_path__ + "static/img/权限隔离@2x1.9865c688.png";